<template>
  <div>
    <img v-if="isStaff(this.query.user)" title="Kirjastopalvelu Oy" src="/images/extranet/images/kp.png" width=56 class="img-circle" style="border: 2px solid #EF483E;">

    <span v-if="!isStaff(this.query.user)" class="fa-stack fa-2x">
      <i class="fa fa-circle fa-stack-2x" 
        :style="`color: ${ backgroundColor }`"></i>
      
      <span class="fa-stack-1x calendar-text" style="text-transform: uppercase; color: white;">
          {{ firstLetter }}
      </span>
    </span>
  </div>    
</template>

<script>

import { ColorHelpers } from '@/helpers/ColorHelpers.js'

import { userMixin } from '@/mixins/userMixin.js'

export default {
  mixins: [
    userMixin,
  ],

  props: {
    query: Object,
    parentId: Number,
  },

  computed: {
    
    name() {
      return this.userName(this.query.user) || this.query.user_id.toString()
    },

    firstLetter() {
      return this.name.charAt(0)
    },

    backgroundColor() {
      return (new ColorHelpers).getColor(this.name)
    }
  },

}

</script>
